import React from 'react';


class Helper extends React.Component {
  // get a float number and output a "HHMMSS" format
  static fToHHMMSS(f) {
    let sec_num = parseInt(f, 10); // don't forget the second param
    let hours   = Math.floor(sec_num / 3600);
    let minutes = Math.floor((sec_num - (hours * 3600)) / 60);
    let seconds = sec_num - (hours * 3600) - (minutes * 60);

    if (hours   < 10) {hours   = "0" + hours;}
    if (minutes < 10) {minutes = "0" + minutes;}
    if (seconds < 10) {seconds = "0" + seconds;}
    if(hours == "00") {
      return minutes + ':' + seconds;
    }
    else {
      return hours + ':' + minutes + ':' + seconds;
    }
  }

  static getFileSizeStr(fileSize) {
    var resultSize = fileSize / 1024;
    if (resultSize < 1024) {
      return resultSize.toFixed(0) + " KB";
    }
    resultSize = resultSize / 1024;
    if (resultSize < 1024) {
      return resultSize.toFixed(1) + " MB";
    }
    resultSize = resultSize / 1024;
    return resultSize.toFixed(2) + " GB";
  }

  static validateInput(inputStr) {
    if (inputStr.length === 0 || inputStr === "") {
      return false;
    }
    else {
      return true;
    }
  }

  static convertXYtoYawPitch(xPercentage, yPercentage) {
    let yaw = xPercentage * 180;
    if (xPercentage < 0) {
      yaw = ((1 + xPercentage) * 180) + 180;
    }
    let pitch = yPercentage * 90;
    return {yaw: yaw, pitch: pitch};
  }

  static dateToTimestamp(date) {
    // input: JavaScript Date Object
    // output: yyyy-MM-dd HH:mm:ss
    let result = date.getUTCFullYear()
      + "-" + ("0" + (date.getUTCMonth() + 1)).slice(-2)
      + "-" + ("0" + date.getUTCDate()).slice(-2)
      + " " + ("0" + date.getUTCHours()).slice(-2)
      + ":" + ("0" + date.getUTCMinutes()).slice(-2)
      + ":" + ("0" + date.getUTCSeconds()).slice(-2)
      ;
    return result;
  }

  static dateToTimestampShort(date){
    // input: JavaScript Date Object
    // output: yyyy-MM-dd
    let result = date.getUTCFullYear()
      + "-" + ("0" + (date.getUTCMonth() + 1)).slice(-2)
      + "-" + ("0" + date.getUTCDate()).slice(-2)
      ;
    return result;
  }

  static timestampToDateString(timestamp) {
    // input: yyyy-MM-dd HH:mm:ss
    // output: yyyy-MM-ddTHH:mm:ssZ
    let result = timestamp;
    result += "Z";
    result = result.slice(0, 10) + "T" + result.slice(11);
    return result;
  }

  static UTCTimestampSecondsBetween(time1, time2){
    var date1 = new Date(time1);
    var date2 = new Date(time2);
    // console.log(Math.abs(date1-date2)/1000);
    // console.log("date1: " + date1 + " date2: " + date2);
    return Math.abs(date1-date2)/1000;
  }
}

export default Helper;
